import { Selector } from "@ngxs/store";

import { AccountInfo, MapData, User, Vehicle } from "../../core/models";

import { UserState, UserStateModel } from "./user.state";
import { IRequestsNestedState } from "../interfaces/requests.interface";

export class UserGetterState {
  @Selector([UserState])
  static getUserState(state: UserStateModel): UserStateModel {
    return state;
  }

  @Selector([UserState])
  static getCurrentUser(state: UserStateModel): User | null {
    if (!state.entities) {
      return null;
    }

    return state.entities[state.currentUserId];
  }

  @Selector([UserState])
  static getCurrentUserPendingVehicles(state: UserStateModel): Vehicle[] {
    return state.currentUserPendingVehicles;
  }

  @Selector([UserState])
  static getMapData(state: UserStateModel): MapData {
    return state.mapData;
  }

  @Selector([UserState])
  static getAccessToken(state: UserStateModel): string {
    return state.accessToken;
  }

  @Selector([UserState])
  static getAccountInfo(state: UserStateModel): AccountInfo {
    return state.accountInfo;
  }

  @Selector([UserGetterState.getCurrentUser])
  static getCurrentUserAccessLevel(user: User): number {
    return user.usrAccessLevel;
  }

  @Selector([UserGetterState.getCurrentUser])
  static hasCurrentUserPremiumAccess(user: User): boolean {
    return user.premium?.isPremiumMember;
  }

  // New selectors
  @Selector([UserState])
  static getCurrentUserRequestState(
    state: UserStateModel
  ): IRequestsNestedState {
    return state.currentUserRequestState;
  }

  @Selector([UserState])
  static getAccountInfoRequestState(
    state: UserStateModel
  ): IRequestsNestedState {
    return state.getAccountInfoRequestState;
  }

  @Selector([UserState])
  static getMapDataRequestState(state: UserStateModel): IRequestsNestedState {
    return state.mapDataRequestState;
  }

  @Selector([UserState])
  static getSubscribeToPremiumPlanRequestState(
    state: UserStateModel
  ): IRequestsNestedState {
    return state.subscribeToPremiumPlanRequestState;
  }

  @Selector([UserState])
  static getRenewUserVehiclesSubscriptionPutRequestState(
    state: UserStateModel
  ): IRequestsNestedState {
    return state.renewUserVehiclesSubscriptionPutRequestState;
  }
}
